import { Component } from '@angular/core';
import { bootstrapCircleFill, bootstrapFacebook, bootstrapLinkedin, bootstrapTwitterX, bootstrapYoutube } from '@ng-icons/bootstrap-icons';
import { NgIcon, provideIcons } from '@ng-icons/core';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: ``,
  imports: [NgIcon],
  viewProviders: [provideIcons({ bootstrapCircleFill, bootstrapFacebook, bootstrapLinkedin, bootstrapTwitterX, bootstrapYoutube })],
})
export class FooterComponent {

}
